/**
  基础接口定义
*/
import { stringify } from 'qs';
import request, { format } from '@/utils/request';

// 最新提供的新的后台类目接口type:1-新增 2-报错 cateType1-境内 2-境外
export async function fetchNewBackCates(payload = {}) {
  const params = stringify(payload);
  return format(request(`/mdc/base/cate/cateTree?${params}`));
}
// 最新提供的新的前台类目接口, districtId, backCateId
export async function fetchNewFrontCates(payload = {}) {
  const params = stringify(payload);
  return format(request(`/mdc/base/cate/frontCate?${params}`));
}
// 根据城市获取电话区号接口
export async function fetchPhoneAreaCode(payload = {}) {
  const { cityId } = payload;
  return format(request(`/mdc/base/gis/cityAreaCode?cityId=${cityId || ''}`));
}
